import { render } from "./HomeTerminal.vue?vue&type=template&id=422320e0"
import script from "./HomeTerminal.vue?vue&type=script&lang=js"
export * from "./HomeTerminal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__